import React, { useState, useEffect, useContext } from "react";
import { Form, Row, Col, Table, Alert, Container } from "react-bootstrap";
import axios from "axios";

import Preloader from "../../../shared/PreLoaders";
import { Authorization } from "../../../Context/Authorization";

const ManageAuditRenewal = () => {
  const [vfcId, setVfcId] = useState("");
  const [vfcs, setVfcs] = useState([]);
  const [dataType, setDataType] = useState("");
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  // Fetch VFCs
  useEffect(() => {
    setLoading(true);
    const fetchVfc = async () => {
      const config = Authorization();
      try {
        const response = await axios.get(`${Api}/api/vfcs`, config);
        const data = response.data.vfcs;
        setVfcs(data);
      } catch (error) {
        console.log("Error fetching VFC data", error);
      }
      setLoading(false);
    };
    fetchVfc();
  }, [Api]);

  // Fetch data based on VFC and data type (Audit or Renewal)
  const handleFetchData = () => {
    if (vfcId && dataType) {
      const endpoint = dataType === "Audit" ? "audits" : "renewal";
      axios
        .post(`${Api}/api/${endpoint}/previous`, { vfcId })
        .then((response) => {
          setData(response.data);
          setError(null); // Clear previous errors
        })
        .catch((err) => {
          console.error(`Error fetching ${dataType} data`, err);
          setError(`No Data for ${dataType} data.`);
        });
    }
  };

  // Trigger data fetch when both vfcId and dataType are selected
  useEffect(() => {
    handleFetchData();
  }, [vfcId, dataType]);

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title">Manage Audit/Renewal </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Manage Audit/Renewal
            </li>
          </ol>
        </nav>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}
      <Container>
        <>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <Form>
                  <Row>
                    <Col>
                      <Form.Group controlId="formVFC">
                        <Form.Label>Select VFC</Form.Label>
                        <div className="input-container">
                          <Form.Control
                            as="select"
                            value={vfcId}
                            onChange={(e) => setVfcId(e.target.value)}
                            required
                          >
                            <option value="">-- Select VFC --</option>
                            {vfcs.map((vfc) => (
                              <option key={vfc._id} value={vfc._id}>
                                {vfc.vfcName}
                              </option>
                            ))}
                          </Form.Control>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="formDataType">
                        <Form.Label>Select Data Type</Form.Label>
                        <div className="input-container">
                          <Form.Control
                            as="select"
                            value={dataType}
                            onChange={(e) => setDataType(e.target.value)}
                            required
                          >
                            <option value="">-- Select Data Type --</option>
                            <option value="Audit">Audit</option>
                            <option value="Renewal">Renewal</option>
                          </Form.Control>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>

          <Row>
            <Col md={12}>
              <p className="breadcrumb-item active" aria-current="page">
                Data ({dataType})
              </p>
              <div className="card">
                <div className="card-body">
                  <div className="row icons-list">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr className="table table-hover">
                            <th>#</th>
                            <th>VFC Name</th>
                            <th>Date</th>
                            {dataType === "Audit" ? (
                              <>
                                <th>Balance During Audit</th>
                                <th>Auditor Name</th>
                              </>
                            ) : (
                              <th>Renewal No</th>
                            )}
                            <th>Document</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.vfcId.vfcName}</td>
                              <td>
                                {new Date(
                                  dataType === "Audit"
                                    ? item.auditDate
                                    : item.renewalDate
                                ).toLocaleDateString()}
                              </td>
                              {dataType === "Audit" ? (
                                <>
                                  <td>{item.balanceDuringAudit}</td>
                                  <td>{item.auditorName}</td>
                                </>
                              ) : (
                                <td>{item.renewalNo}</td>
                              )}
                              <td>
                                <a
                                  href={item.uploadDocument}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View Document
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </>
      </Container>
    </div>
  );
};

export default ManageAuditRenewal;
